import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';

import PATH from '@/constants/path';
import useUser from '@/hooks/use-user.hook';
import SuspensePage from '@/pages/suspense';

export default function ProtectedLayout() {
  const { isSignedIn, logoff, isPendingUser } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSignedIn && !isPendingUser) {
      logoff().then(() => {
        navigate(PATH.INDEX);
      });
    }
  }, [isSignedIn, logoff, isPendingUser, navigate]);

  return !isSignedIn ? <SuspensePage /> : <Outlet />;
}
